import { useState } from 'react'

function SharePost({ title }) {
  const [copied, setCopied] = useState(false)
  const url = typeof window !== 'undefined' ? window.location.href : ''
  const encUrl = encodeURIComponent(url)
  const encTitle = encodeURIComponent(title || '')
  const shareText = `Hey, check out this post about ${title} on ${url}`
  const encShareText = encodeURIComponent(shareText)

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareText)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      // ignore clipboard errors
    }
  }

  const linkClass =
    'font-mono text-[12px] text-soft-faint hover:text-soft-dim border-b border-soft-rule pb-0.5 transition-colors'

  return (
    <div className="flex items-center gap-6">
      <span className="font-mono text-[11px] uppercase tracking-[0.6px] text-soft-faint">Share</span>
      <a
        href={`https://twitter.com/intent/tweet?text=${encShareText}`}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClass}
      >
        X
      </a>
      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encUrl}&title=${encTitle}`}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClass}
      >
        LinkedIn
      </a>
      <button
        onClick={copyLink}
        className={`${linkClass} cursor-pointer bg-transparent`}
      >
        {copied ? 'Copied' : 'Copy link'}
      </button>
    </div>
  )
}

export default SharePost
